define(function (require) {
    var $ = require("jquery");
    var dataLayer = window.dataLayer || [];

    var handlers = {
        click: {
            btnLoadAll: function (e) {
                e.preventDefault();

                var $this = $(this);

                $("#tblMyDocs")
                    .find("tr:hidden")
                    .show("slow", function () {
                        $this.hide();
                    });

                return false;
            },
            downloadLink: function (e) {
                var $this = $(this);
                var $row = $this.parents("tr:first");

                dataLayer.push({
                    event: "gaEvent",
                    eventCategory: "Download",
                    eventAction: $this.attr("data-analytics-path"),
                    eventLabel: $this.text()
                });

                $row.removeClass("unread");
            }
        }
    };

    var init = function () {
        $("#btnLoadAll").on("click", handlers.click.btnLoadAll);
        $("#tblMyDocs a.download").on("click", handlers.click.downloadLink);

        $("#tblMyDocs")
            .closest(".document-table")
            .find(".mobile-scroll-indicator .left")
            .on("click", function () {
                var currentScroll = $(".document-table .table-responsive").scrollLeft();
                $(".document-table .table-responsive").animate({ scrollLeft: currentScroll - 300 }, 300);
            });
        $("#tblMyDocs")
            .closest(".document-table")
            .find(".mobile-scroll-indicator .right")
            .on("click", function () {
                var currentScroll = $(".document-table .table-responsive").scrollLeft();
                $(".document-table .table-responsive").animate({ scrollLeft: currentScroll + 300 }, 300);
            });
    };

    init();
});
